import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const FullBleed = ({ src, alt, quote, testid }) => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

    return (
        <div ref={ref} data-testid={testid} className="relative h-[32vh] sm:h-[40vh] overflow-hidden" style={{ position: "relative" }}>
            <motion.div style={{ y }} className="absolute inset-[-14%]">
                <img src={src} alt={alt} className="w-full h-full object-cover" loading="lazy" />
            </motion.div>
            {quote && (
                <>
                    <div className="absolute inset-0 bg-[#161412]/30" />
                    <div className="absolute inset-0 flex items-center justify-center px-6">
                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-100px" }}
                            transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
                            className="font-serif font-light italic text-[#FAF8F5] text-2xl sm:text-4xl lg:text-5xl text-center max-w-3xl leading-snug"
                        >
                            {quote}
                        </motion.p>
                    </div>
                </>
            )}
        </div>
    );
};
